import React, {useEffect, useState} from 'react';
import ReservationMaterialEstimateUnitTable
    from "../../../../components/UI/table/warehouse/reservation/ReservationMaterialEstimateUnitTable";
import {useLocation, useParams} from "react-router-dom";
import {Box} from "@mui/material";
import Typography from "@mui/material/Typography";
import MaterialReserveService from "../../../../API/orders/reservation/MaterialReserveService";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../../Constants";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {materialReserveState} from "../../../../data/MaterialReserveState";

const ReservationMaterialEstimateUnit = () => {
    const [data, setData] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const pathname = useLocation().pathname
    const params = useParams();

    const {
        materialEstimateUnitId,
        estimateId,
        estimateState,
        orderId,
        orderNumber,
        orderHeaderId,
        year,
        isButtonPurchase,
        isSlab,
        articleNumber,
        type,
        name,
        isIssue,
        status,
        baseUnit
    } = params

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    useEffect(() => {
        getStartPageSize()
        MaterialReserveService.getAllByMaterialEstimateUnitId(type, materialEstimateUnitId).then(function (response) {
            const data = response.data;
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: response.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Резервы"}
                path={[
                    {name: "Главная", href: "/"},
                    {
                        name: "Смета",
                        href: '/organization/orders/' + orderId + '/' + orderNumber + '/' + orderHeaderId + '/' + year
                    },
                    {
                        name: name,
                        href: '/organization/orders/' + orderId + '/' + orderNumber + '/' + orderHeaderId + '/' + year + '/estimate/' + estimateId + "/" + estimateState
                    }

                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Резервы
                    </Typography>
                    <Typography>{`Арикул: ${articleNumber === "null" ? "" : articleNumber}`}</Typography>
                    <Typography>{`Наименование: ${name}`}</Typography>
                    <Typography>{`Статус: ${materialReserveState[status]}`}</Typography>
                </Box>
                <ReservationMaterialEstimateUnitTable
                    data={data}
                    setData={setData}
                    orderId={orderId}
                    nameOrder={orderNumber}
                    orderHeaderId={orderHeaderId}
                    year={year}
                    isEstimate={true}
                    estimateId={estimateId}
                    isButtonPurchase={isButtonPurchase}
                    isSlab={isSlab}
                    isColumnOrder={false}
                    isIssue={isIssue === "true"}
                    type={type}
                    enableEditing={true}
                    materialEstimateUnitId={materialEstimateUnitId}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    status={status}
                    nameMaterial={name}
                    articleNumber={articleNumber}
                    baseUnit={baseUnit}
                    estimateState={estimateState}
                />
                <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                    return {...alert, open: false}
                })}/>
            </Box>
        </Box>
    );
};

export default ReservationMaterialEstimateUnit;